// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconCurrencyRipple } from '@tabler/icons';

const icons = {
    IconCurrencyRipple
};

// ==============================|| MENU ITEMS - EXPENSES ||============================== //

const expenses = {
    id: 'expenses',
    title: <FormattedMessage id="expenses" />,
    icon: icons.IconCurrencyRipple,
    type: 'group',
    url: 'expenses',
    roles: ['employee', 'employer']
};

export default expenses;
